import GuideButtons from 'sections/Dashboard/features/SetupGuide/components/GuideButtons'
import { useTranslation } from 'react-i18next'

function GuideIntro({ onNext }) {
  const { t } = useTranslation()

  return (
    <div className="book-setup-guide-modal-container section-container">
      <div className="book-setup-guide-modal-container-content">
        <div className="text-center mt-5">
          <h2>{t('book_setup_guide_first_title')}</h2>
        </div>
        <p className="text-center mb-5 pl-1 pr-1">
          {t('book_setup_guide_first_subtitle')}
        </p>

        <div className="pl-3 pr-3 ml-5 mr-5 mt-5 mb-5">
          <p>{t('book_setup_guide_first_content1')}</p>
          <p>{t('book_setup_guide_first_content2')}</p>
          <p>{t('book_setup_guide_first_content3')}</p>
          <p>{t('book_setup_guide_first_content4')}</p>
        </div>

        <div className="pl-3 pr-3 ml-5 mr-5 mt-5 mb-5">
          <p>{t('book_setup_guide_first_content5')}</p>
        </div>
      </div>

      <GuideButtons onNext={onNext} />
    </div>
  )
}

export default GuideIntro
